module.exports = __webpack_public_path__ + "static/img/icn_v_innovacion.464986f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_v_innovacion.svg
// module id = d6ja
// module chunks = 1